import styled from 'styled-components';
import { contentWidth, mobileThreshold, smallContentWidth, smallThreshold } from '../../../../Constants/layoutValues';
import { cssVarColors } from '../../../../Constants/cssVarColors';

export const BulletSectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding-bottom: 2em;
	margin-bottom: 4em;
	margin-top: 2em;
	@media (max-width: ${mobileThreshold}px) {
		padding-top: 1rem;
		//margin-top: 0;
	} ;
`;

export const BulletHeadingWrapper = styled('div')`
	font-size: 3em;
	font-weight: 700;
	padding-bottom: 1em;
	background: linear-gradient(90deg, ${cssVarColors.highlight} 0%, ${cssVarColors.onSurface} 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	padding-top: 4rem;
	@media (max-width: ${mobileThreshold}px) {
		text-align: center;
		font-size: 1.75rem;
		width: 100%;
		padding-top: 2rem;
		padding-bottom: 1em;
	}
`;

export const BulletSectionCard = styled('div')`
	width: ${contentWidth};
	box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
	padding: 1em;
	padding-top: 2em;
	padding-bottom: 2em;
	display: flex;
	flex-direction: column;
	@media (max-width: ${smallThreshold}px) {
		width: ${smallContentWidth};
	}
	@media (max-width: ${mobileThreshold}px) {
		flex-direction: column;
		margin: 0.5em;
		width: auto;
		padding-top: 1rem;
	} ;
`;

export const SupportingContent = styled.div`
	display: flex;
	flex-direction: row;
	align-items: stretch;      /* ← now all children (text + image) stretch to same height */
	justify-content: center;
	padding-left: 2em;
	
	@media (max-width: ${mobileThreshold}px) {
		flex-direction: column;
		padding-left: 0;
		padding-bottom: 2em;
	}
`;

export const SupportingContentHeadingWrapper = styled('div')`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 2em;
	font-weight: 100;
	padding-bottom: 1em;
	color: ${cssVarColors.primary};
	
	@media (max-width: ${mobileThreshold}px) {
		font-size: 1.3em;
	} ;
`;

export const SupportingContentHeading = styled('div')`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	line-height: 1.6;
	@media (max-width: ${mobileThreshold}px)
	{
		font-size: .8rem;
	};
`;

export const SupportingContentImageWrapper = styled.div<{image: string}>`
	flex: 1;
	align-self: stretch;
	background-image: url(${p => p.image});
	background-size: contain;
	background-position: top center;
	background-repeat: no-repeat;
	background-color: #fff;
	overflow: hidden;
	
	@media (max-width: ${mobileThreshold}px) {
		background-size: contain;
		background-repeat: no-repeat;
		background-position: top center;
		min-height: 400px;   /* fill the text‐driven height */
		margin-bottom: 2rem;
	}
`;

export const BulletPointSection = styled('div')`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
`;

export const BulletWrapper = styled('div')`
	display: flex;
	flex-direction: row;
	padding-top: 0em;
	padding-bottom: 0.5em;
	font-size: 1.8em;
	padding-left: 1.5rem;
	align-items: flex-start;
	justify-content: flex-start;
	padding-right: 1em;
	line-height: 1.6;
	@media (max-width: ${mobileThreshold}px) {
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		font-size: 1.2em;
	} ;
`;

export const BulletIcon = styled('div')`
	height: 100%;
	font-size: 1.5em;
	color: ${cssVarColors.highlight}bb;
	position: relative;
	top: -1rem;
	padding-right: 0.5em;
	@media (max-width: ${mobileThreshold}px) {
		font-size: 1.2em;
		top: -0.5rem;
	} ;
`;

export const BulletPointContent = styled('div')`
	flex-grow: 1;
	font-weight: 100;
	font-size: 0.8em;
	//display: flex;
	//flex-direction: row;
	//justify-content: flex-start;
	//align-items: flex-start;
`;

export const BulletPointTitle = styled('span')`
	display: inline;
	font-weight: 900;
`;

export const BulletPointText = styled('span')`
	display: inline;
`;

export const SupportingContentImage = styled('img')`
	max-height: 100%;
	max-width: 100%;
`;
